import mitt from 'mitt'

export const eventBus = mitt()

export const interceptorCallback = (obj, callback) => {
  eventBus.emit('on-callback', obj, callback)
}
